import { RefObject, useEffect } from 'react';

interface Props {
  searchRef: RefObject<HTMLDivElement>;
  inputRef: RefObject<HTMLDivElement>;
  setSearchToken: (searchString: string) => void;
}

const useClickOutsideSearch = ({ searchRef, inputRef, setSearchToken } : Props): void => {
  useEffect(() => {
    function handleClickOutside(event): void {
      if (searchRef.current && !searchRef.current.contains(event.target)
        && inputRef.current && !inputRef.current.contains(event.target)) {
        setSearchToken('');
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [searchRef, inputRef, setSearchToken]);
};

export default useClickOutsideSearch;
